import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import uRLs from "../../../utils/baseUtils";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";

const InviteHub = () => {
    const { token } = useParams();
    const [isPreLoading, setPreLoading] = useState(false);
    const [isPreText, setPreText] = useState("Your invitation is currently being processed...");
    const navigate = useNavigate();

    const { checkNetwork } = useNetwork();
    const showAlert = useShowAlert();

    const handleInvite = async (token) => {
        setPreLoading(true);
        try {
            if (!checkNetwork()) return;
            const response = await axios.get(`${uRLs.API_URL}invite-hub`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            showAlert("success", Messages.SUCCESS.INVITE_SUCCESS);
            const snackbarDisplayTime = 1000;
            setTimeout(() => {
                navigate('/login');
            }, snackbarDisplayTime);
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } finally {
            setPreLoading(false);
        }
    }

    useEffect(() => {
        handleInvite(token);
    }, [token]);

    return (
        <div className="wrapper">
            <div className="authentication-forgot d-flex align-items-center justify-content-center">
                <div className="card forgot-box">
                    <div className="card-body">
                        <div className="p-3 text-center">
                            <div className="text-center mb-3">
                                <img src="/assets/images/logo-icon.png" width="40" alt="Login" />
                            </div>
                            <h4 className="mt-3 font-weight-bold">Invitation</h4>
                            {isPreLoading ? (
                                <p className="text-muted">Your invitation is processing...</p>
                            ) : (
                                <>
                                    <p className="text-muted mb-0">{isPreText}</p>
                                    <p>Ask your sharer to invite you again.</p>
                                </>
                            )}
                            <div className="d-grid gap-2">
                                {isPreLoading ? (
                                    <button className="btn btn-primary pb-0 text-right" disabled>
                                        <CircularProgress size={22} className="text-white" />
                                    </button>
                                ) : ("")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InviteHub;